<template>
<div class="mt-3">
  <!-- <h1 class="text-60">404</h1> -->
  <div class="page-404">
    <img :src="`${publicPath}assets/images/404.png`" alt="">
  </div>
  <p class="text-muted text-18">{{$t('errorPageMsg.text')}}</p>
  <a class="btn btn-lg btn-primary btn-rounded" href="dashboard.v1.html">{{$t('goBackToHome.text')}}</a>
</div>
</template>

<script>
export default {
name: "NotFound",
data () {
      return {
        publicPath: process.env.BASE_URL,
      }
    },
}
</script>

<style>
.page-404 {width: 100%; max-width: 500px; margin: auto;}
.page-404 img {width: 100%;}
</style>